<div class="style2023">
  <form (ngSubmit)="search()" style="width: 100%">
    <div class="filterPanel">
      <div class="flex">
        <div class="flex-grow-1">
          <div class="form-group form-grid">
            <div class="input-group">
              <div class="input-group-item flex align-items-center">
                <i
                  class="fa fa-calendar clickable-calendar-icon mr-2"
                  (click)="completedDateFrom.showOverlay()"
                ></i>
                <span
                  (click)="completedDateFrom.showOverlay()"
                  *ngIf="
                    jobCompletedOrCancelledDate &&
                    jobCompletedOrCancelledDate[0] &&
                    !jobCompletedOrCancelledDate[1]
                  "
                  class="mr-1"
                  style="width: 34px"
                >
                  Up to
                </span>
                <p-calendar
                  #completedDateFrom
                  [(ngModel)]="jobCompletedOrCancelledDate"
                  name="completedDateFrom"
                  [selectionMode]="'range'"
                  class="custom-calendar-template"
                  dateFormat="dd/mm/yy"
                  appendTo="body"
                  placeholder="Completed/Cancelled"
                  (onSelect)="setCompletedOrCancelledDateFromAndTo()"
                ></p-calendar>
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item flex align-items-center">
                <i
                  class="fa fa-calendar clickable-calendar-icon mr-2"
                  (click)="lastUpdatedFilter.showOverlay()"
                ></i>
                <span
                  (click)="lastUpdatedFilter.showOverlay()"
                  *ngIf="
                    lastUpdatedFilterValue &&
                    lastUpdatedFilterValue[0] &&
                    !lastUpdatedFilterValue[1]
                  "
                  class="mr-1"
                  style="width: 34px"
                >
                  Up to
                </span>
                <p-calendar
                  #lastUpdatedFilter
                  [(ngModel)]="lastUpdatedFilterValue"
                  name="lastUpdatedFilterValue"
                  [selectionMode]="'range'"
                  class="custom-calendar-template"
                  dateFormat="dd/mm/yy"
                  appendTo="body"
                  placeholder="Last Updated"
                  (onSelect)="setLastUpdatedFromAndTo()"
                ></p-calendar>
              </div>
            </div>

            <div class="input-group">
              <span class="input-group-item">
                <input
                  name="jobNumber"
                  type="text"
                  pInputText
                  [(ngModel)]="filterVal.filters.jobNumber.value"
                  placeholder="Search Job Ref."
                />
              </span>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="jobStatuses"
                  [options]="jobStatuses"
                  [(ngModel)]="filterVal.filters.jobStatusList.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="All Job Statuses"
                ></p-multiSelect>
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="expenseStatus"
                  [options]="expenseStatuses"
                  [(ngModel)]="filterVal.filters.expenseStatuses.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="Expense Statuses"
                ></p-multiSelect>
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="additionalChargeTypes"
                  [options]="additionalChargeTypes"
                  [(ngModel)]="filterVal.filters.additionalChargeTypeList.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="Filter By Charge Types"
                ></p-multiSelect>
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <input
                  name="supplier"
                  type="text"
                  pInputText
                  [(ngModel)]="filterVal.filters.supplier.value"
                  placeholder="Supplier"
                />
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="customerList"
                  [options]="customerList"
                  [(ngModel)]="filterVal.filters.customerList.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="All Customers"
                ></p-multiSelect>
              </div>
            </div>
            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="assigneeOptions"
                  [options]="assigneeOptions"
                  [(ngModel)]="filterVal.filters.assigneeOptions.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="Filter by assignees"
                ></p-multiSelect>
              </div>
            </div>

            <div class="input-group">
              <div class="input-group-item">
                <p-multiSelect
                  name="customerInvoicePeriods"
                  [options]="customerInvoicePeriodOptions"
                  [(ngModel)]="filterVal.filters.customerInvoicePeriods.value"
                  class="filter-dropdown input-group-filter"
                  defaultLabel="All Invoice Periods"
                ></p-multiSelect>
              </div>
            </div>
          </div>
        </div>
        <div class="square-buttons flex align-items-end ml-2">
          <button
            pButton
            type="submit"
            label="Search"
            [disabled]="isLoading"
            class="button-style btn-md ui-primary-button my-0"
            icon="fa ui-icon-search"
          ></button>
          <button
            pButton
            type="button"
            icon="ui-icon-refresh"
            class="button-style btn-md ui-tertiary-button ml-2 mb-0"
            (click)="refresh(dataTable)"
          ></button>
        </div>
      </div>
    </div>
  </form>
</div>
<p-progressBar
  *ngIf="isLoading"
  mode="indeterminate"
  class="ui-progressbar-indeterminate"
></p-progressBar>

<p-table
  #dataTable
  selectionMode="single"
  [value]="page.items"
  [rows]="filterVal?.rows"
  [responsive]="true"
  [paginator]="true"
  [rowHover]="true"
  [sortField]="filterVal?.sortField"
  [sortOrder]="filterVal?.sortOrder"
  [first]="filterVal?.first"
  [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
  [pageLinks]="8"
  [totalRecords]="page.total"
  [resizableColumns]="true"
  [(selection)]="selectedJob"
  (onRowSelect)="onRowSelect($event)"
  styleClass="inbox-data-table dataTable"
  [loading]="isLoading"
>
  <ng-template pTemplate="header">
    <tr class="no-wrap-cells">
      <th pSortableColumn="completedOrCancelledDateSort" [style]="{ width: '90px' }">Completed</th>
      <th pSortableColumn="expenseStatus" [style]="{ width: '190px' }">Status</th>
      <th pSortableColumn="assignees" [style]="{ width: '190px' }">Assignees</th>
      <th pSortableColumn="jobNumber" [style]="{ width: '140px' }">Job Number</th>
      <th [style]="{ width: '130px' }">Vehicle Reg</th>
      <th [style]="{ width: '155px' }" pSortableColumn="supplierName">Supplier</th>
      <th [style]="{ width: '155px' }" pSortableColumn="customerName">Customer</th>
      <th pSortableColumn="amount" style="width: 70px">Amount</th>
      <th style="width: 200px">Pending Charge Types</th>
      <th *ngIf="showCustomerInvoicePeriodColumn" [style]="{ width: '190px' }">Inv Periods</th>
      <th pSortableColumn="lastUpdatedSort" [style]="{ width: '90px' }">Updated</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-itemAny>
    <ng-container *ngIf="inboxJob(itemAny) as item">
      <tr
        (dblclick)="editJob(item, $event)"
        [pSelectableRow]="item"
        class="no-wrap-cells"
        style="height: 51px"
      >
        <td>
          <div>
            <div>
              {{ item.completedOrCancelledDate | datex : 'DD/MM/YYYY' }}
            </div>
          </div>
        </td>
        <td style="text-wrap: auto">
          {{ item.expenseStatus }}
        </td>
        <td style="text-wrap: auto">
          {{ item.assignees }}
        </td>
        <td>
          <div [class.job-unclicked]="!item.clicked" title="{{ item.jobNumber }}">
            <a (click)="editJob(item, $event)">{{ item.jobNumber }}</a>
          </div>
        </td>
        <td>{{ item.vehicleReg }}</td>
        <td>
          <!--        <div title="{{ item.supplier }}">-->
          <!--          <a (click)="goToSupplier(item)">{{ item.supplierName }}</a>-->
          <!--        </div>-->
          {{ item.supplierName }}
        </td>
        <td>
          <div title="{{ customersCountPostfix(item) }}">
            {{ customersCountPostfix(item) }}
          </div>
        </td>
        <td class="text-center">
          <div title="{{ item.amount }}">
            {{ item.amount }}
          </div>
        </td>
        <td style="text-wrap: auto">
          <div>
            {{ item.pendingExpenseTypes }}
          </div>
        </td>
        <td *ngIf="showCustomerInvoicePeriodColumn" style="text-wrap: auto">
          {{ item.customerInvoicePeriodNames }}
        </td>
        <td>
          <div title="{{ item.lastUpdated | datex : 'ddd DD MMM \'YY' }}">
            {{ item.lastUpdated | datex : 'DD/MM/YYYY' }}
          </div>
        </td>
      </tr>
    </ng-container>
  </ng-template>
</p-table>

<div class="footerPanel ui-grid-row">
  <button
    class="btn-to-right"
    type="button"
    [appOpenUrl]="'/app/jobscreen/' + selectedJob?.id"
    icon="fa fa-list"
    label="Job Details"
    pButton
    [disabled]="!selectedJob"
  ></button>
  <button
    class="btn-to-right"
    icon="fa fa-cloud-download"
    type="button"
    (click)="downloadToCSV()"
    label="Download to CSV"
    pButton
  ></button>
  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="showPriceDetails()"
    icon="fa fa-info"
    label="Price Details"
    pButton
    [disabled]="!selectedJob"
  ></button>
  <button
    class="pull-right ui-sm-12 mt-1"
    type="button"
    (click)="displayChangeAssigneeDialog = true"
    label="Change Assignee"
    pButton
    [disabled]="!selectedJob"
  ></button>
</div>

<change-assignee
  *ngIf="selectedJob"
  [jobId]="selectedJob.id"
  [(visible)]="displayChangeAssigneeDialog"
  [assigneeAdditionalChargeId]="selectedJob.pendingExpenseIds[0]"
  [hideAssignAllCheckbox]="true"
  (assigneeChanged)="search()"
>
</change-assignee>
